export default {
  generalTitle:
    'Browse our Royalty Free Music Library for Your Videos - Loudly',
  generalContentDescription:
    "Browse our music library for your video's music with one simple license. Find the perfect Royalty Free track for your videos, YouTube channels, podcasts, advertising, websites, apps and more.",
  songDetailsTitle: 'Loudly Soundtracks',
  songDetailsContentDescription:
    'Listen to {{songTitle}} on Soundtracks and download the royalty free track for your video, app, YouTube channel or other platforms',
};
